import Image from 'next/image';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useEffect, useState, useRef } from 'react';
import { Container } from 'react-bootstrap';
import { dataLayerSendEvent } from 'Epharmacy/EpharmacyAnalytics';
import TimerBanner from '../TimerBanner/TimerBanner';
import { getReplaceHtmlTags, MIN_MOBILE_WIDTH, getImageUrlWithSize } from '@common/Utility/common-utils';
import { ONE_ASTER_CATEGORY_HOME, PAGE_TITLES } from '@common/Utility/constants';
import { sendEventToSmartLook } from '@common/Utility/smartlook';
import { StaticBannerWithImageStyled } from './StaticBannerWithImageStyled';
import withAnalytics from '../Hoc/WithAnalytics';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';

const StaticBannerWithImage = (props) => {
const generateUrl = useNavigationURL();
  const { data, analyticsProps } = props;
  const router = useRouter();
  const inViewRef = useRef();
  const bannerViewEventFired = useRef();
  const commonAnalytics = {
    screen_name:
      analyticsProps?.screenName ||
      (router?.query?.slugname
        ? router?.query?.slugname
        : props?.pageName === ONE_ASTER_CATEGORY_HOME?.PHARMACY
        ? 'epharmacy homepage'
        : props?.pageName === ONE_ASTER_CATEGORY_HOME?.CORE
        ? 'asco homepage'
        : props?.pageName === ONE_ASTER_CATEGORY_HOME?.DOCTOR
        ? 'doctor consult homepage'
        : props?.pageName),
    page_type: analyticsProps?.pageType || props?.pageType,
    referrer_page: analyticsProps?.referrerPage || props?.referrerPage,
  };

  const [middleBanner] = useState(data);
  const [windowWidth, setWindowWidth] = useState();
  const [isBannerVisible, setIsBannerVisible] = useState(true);

  const handleTimerVisibilityChange = (isVisible) => {
    if (isVisible === false && data[0]?.showTimer) {
        setIsBannerVisible(false);
    }
  };

  const onBannerClick = (item) => {

    const bannerProps = {
      banner_name: props?.sectionName,
      banner_url: item?.imageWeb,
      banner_position: Number(item?.order),
      banner_id: item?.name ? item?.name + '_' + item?.id : getReplaceHtmlTags(item?.altText) + '_' + item?.id,
      banner_title: item?.name ? item?.name + '_' + item?.order : getReplaceHtmlTags(item?.altText) + '_' + item?.order,
    };
    if (analyticsProps && Object.keys(analyticsProps).length !== 0) {

      dataLayerSendEvent('banner_click', { ...analyticsProps, ...bannerProps });

    } else {

      dataLayerSendEvent('banner_click', { ...commonAnalytics, ...bannerProps });

    }

    const properties = {
      type: props?.pageName,
    };
    sendEventToSmartLook('banner_click', properties);
    if (item?.linkWeb !== '') {
      if (item?.linkWeb.indexOf('http') === -1) {
        if (item?.linkWeb.includes('?')) {
          router.push({
            pathname: generateUrl(item?.linkWeb.split('?')[0]),
            query: item?.linkWeb.split('?')[1],
          });
        } else {
          router.push({
            pathname: generateUrl(item?.linkWeb),
          });
        }
      } else {
        window.open(generateUrl(item?.linkWeb), '_self');
      }
    }
  };

  useEffect(() => {
    setWindowWidth(window.innerWidth);
  }, []);

  const sendBannerImpressionEvent = (responseData) => {
    if (!responseData) return;
    responseData?.map((responseData) => {
      dataLayerSendEvent('banner_impression', {
        ...commonAnalytics,
        myaster_category: analyticsProps?.myaster_category,
        banner_name: props?.sectionName,
        banner_url: responseData?.imageWeb,
        banner_position: Number(responseData?.order),
        banner_id: responseData?.name
          ? responseData?.name + '_' + responseData?.id
          : getReplaceHtmlTags(responseData?.altText) + '_' + responseData?.id,
        banner_title: responseData?.name
          ? responseData?.name + '_' + responseData?.order
          : getReplaceHtmlTags(responseData?.altText) + '_' + responseData?.order,
      });
    });
  };

  const handleOnView = () => {
    if (!bannerViewEventFired.current && data) {
      bannerViewEventFired.current = true;
      sendBannerImpressionEvent(data);
    }
  };

  const renderStaticBanner = () => {
    
    if (!data?.length || (!isBannerVisible && data[0]?.showTimer)) return null;

    return (
        <Container className="p-0">
          {data.map((item) => (
            <a
              className="banner"
              key={item.order}
              href={generateUrl(item?.linkWeb)}
              onClick={(e) => {
                e.preventDefault();
                onBannerClick(item);
              }}
            >
              <Image
                src={windowWidth <= MIN_MOBILE_WIDTH ? getImageUrlWithSize(item?.imageMobile, windowWidth) : getImageUrlWithSize(item?.imageWeb, windowWidth)}
                alt={props?.pageName ?? PAGE_TITLES?.ASTER_HOME}
                title={props?.pageName ?? PAGE_TITLES?.ASTER_HOME}
                layout="fill"
                unoptimized
              />
              {data?.[0]?.showTimer && (
                <div className='timerBannerStyle'>
                  <TimerBanner
                    timerTheme = {data?.[0]?.timerTheme}
                    offerStartTime = {data?.[0]?.launchDateTime}
                    offerEndTime = {data?.[0]?.endLaunchDateTime}
                    onVisibilityChange={handleTimerVisibilityChange}
                  />
                </div>
              )}
            </a>
          ))}
        </Container>
    );
  };

  const StaticBannerWithAnalytics = withAnalytics(
    () => (
      <StaticBannerWithImageStyled ref={inViewRef}>
        {renderStaticBanner()}
      </StaticBannerWithImageStyled>
    ),
    handleOnView,
    inViewRef,
  );

  return <StaticBannerWithAnalytics />;
};

StaticBannerWithImage.propTypes = {
  data: PropTypes.any,
  isReload: PropTypes.bool,
  pageName: PropTypes.string,
  sectionName: PropTypes.string,
  analyticsProps: PropTypes.object,
};

export default StaticBannerWithImage;
